import { AdaptiveAuthenticationState } from "@idw-types/state/adaptive-authentication-state";
import { CustomizeBySearchTypes } from "@enums/customize-by-search-types";
import { AdaptiveAuthenticationActionTypes, AdaptiveAuthenticationActions } from "../actions/adaptive-authentication-actions";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";

export const initialAdaptiveAuthenticationState: AdaptiveAuthenticationState = {
    referenceData: {
        isLoading: false,
        adaptiveAuthReportConfigs: null,
        companies: null,
        relyingParties: null,
        rpServices: null,
        workflows: null,
    },
    searchFilters: {
        customizeBySearchType: CustomizeBySearchTypes.VERIFICATION_SERVICE,
        companyId: null,
        rpServiceId: null,
        workflowId: null,
        startDate: getTimeRange(TimeRangeTypes.TODAY).startDate,
        endDate: getTimeRange(TimeRangeTypes.TODAY).endDate,
        timeRangeType: TimeRangeTypes.TODAY
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        adaptiveAuthenticationResults: null
    }
};

export const adaptiveAuthenticationReducer = (
    state: AdaptiveAuthenticationState = initialAdaptiveAuthenticationState,
    action: AdaptiveAuthenticationActions
): AdaptiveAuthenticationState => {
    switch (action.type) {
        // Reference Data
        case AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialAdaptiveAuthenticationState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        // Search
        case AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialAdaptiveAuthenticationState.searchResults }
                        : { ...state.searchResults })
                    ,
                    isLoading: action.payload.isLoading
                }
            };
        case AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    adaptiveAuthenticationResults: action.payload.adaptiveAuthenticationResults,
                    searchDate: new Date()
                }
            };
        default:
            return state;
    }
};